<template>
    <div>
        <el-table :data="list" border style="width: 100%" row-key="id" :expand-row-keys="expands" @expand-change="rowClick"  v-loading="loading">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <component :is="currentView" :key="currentView" :name="currentView"  :order_edit="props.row"></component>
                </template>
            </el-table-column>
            <el-table-column prop="user_name" label="操作人"></el-table-column>
            <el-table-column prop="created_at_memo" label="操作时间"></el-table-column>
            <el-table-column label="执行操作" prop="action_name"></el-table-column>
        </el-table>
        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage"></pagination>
        </el-row>
    </div>
</template>

<script>
    import Pagination from "~/widgets/Pagination.vue";
    import OrderService from "~/services/order";
    import revise_finance from "~/views/order/recoder/revise_finance.vue";
    import fill_invoice from "~/views/order/recoder/fill_invoice.vue";
    import revise_contract from "~/views/order/recoder/revise_contract.vue";
    import add_pay from "~/views/order/recoder/add_pay.vue";
    import update_pay from "~/views/order/recoder/update_pay.vue";
    import delete_pay from "~/views/order/recoder/delete_pay.vue";
    import Config from "~/config/params";
    export default {
        components:{
            Pagination,
            revise_finance,
            fill_invoice,
            revise_contract,
            add_pay,
            update_pay,
            delete_pay
        },
        name: "order",
        props:{
            id:{
                required:true
            }
        },
        computed: {
            currentView: function () {
                let product = this.productMap.find(i => {
                    return i.code == this.block
                });
                return product ? product['component'] : '';
            }
        },
        created(){
            this.getRecord();
        },
        data(){
            return {
                expands:[],
                block:'',
                loading:false,
                list:[],
                linkPage: null,
                productMap: [
                    {code: Config.FINANCE_LINE, name: '财务', component: 'revise_finance'},
                    {code: Config.CONTRACT_LINE, name: '合同', component: 'revise_contract'},
                    {code: Config.FILL_INVOICE, name: '补充发票', component: 'fill_invoice'},
                    {code: Config.ADD_PAY, name: '录入回款', component: 'add_pay'},
                    {code: Config.UPDATE_PAY, name: '更新回款', component: 'update_pay'},
                    {code: Config.EMPTY_PAY, name: '清空回款', component: 'update_pay'},
                    {code: Config.DELETE_PAY, name: '删除回款', component: 'delete_pay'},
                ]
            }
        },
        methods:{
            rowClick(row){
                this.block = row.order_block;
                if (this.expands.indexOf(row.id) < 0) {
                    this.expands = [];
                    this.expands.push(row.id);
                }
            },
            getRecord(){
                OrderService.getRecord({order_id:this.id,is_used:1}).then(res=>{
                    this.list = res.data;
                    this.linkPage = res._meta;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/order.vue